/*
 * @description:
 * @author: Jason Wong
 * @since: 2021-07-06 10:24:04
 */
import config from "@/configs/pathConfigures";
import Layout from "@/views/layout/Layout";
import LayoutEX from "@/views/layout/LayoutEx";
import EditorLayoutView from "@/views/layout/catLayout";
import AlignmentEditorLayoutView from "@/views/layout/AlignmentEditorLayout";

const mainRoute = {
  name: "catMain",
  path: config.prefixUrl,
  component: LayoutEX,
  redirect: { name: "homeIndex" },
  props: {
    routeMapClass: "route-map__float",
  },
  children: [
    {
      name: "translationProject",
      path: "/projects",
      props: { manageable: true},
      component: () => import("@/views/workshop/components/ProjectList.vue"),
      meta: { title: "项目管理" },
    },
    {
      name: "myTasks",
      path: "/tasks",
      props: { manageable: false},
      component: () => import("@/views/workshop/components/ProjectList.vue"),
      meta: { title: "我的任务" },
    },
    {
      name: "tmList",
      path: "/tms",
      component: () => import("@/views/translationMemory/TranslationMemoryList"),
      props: {
        // embeded: true,
        // isInCourseCenter: true,
      },
      meta: { title: "记忆库管理"},
    },
    {
      name: "tbList",
      path: "/tbs",
      component: () => import("@/views/termbase/TermbaseList"),
      props: {
        // isInCourseCenter: true,
        // embeded: true,
      },
      meta: { title: "术语库管理"},
    },
    {
      name: "alignmentTasks",
      path: "/alignmentTasks",
      component: () => import("@/views/alignment/list"),
      props: {
        isInCourseCenter: true,
        embeded: true,
      },
      meta: { title: "双语对齐",isCollapse: false},
    },
    {
      name: "translationMemoryBodyRoute",
      path: "/tm/body",
      component: () => import("@/views/translationMemory/TranslationMemoryBody"),
      meta: { title: "记忆库详情" ,isCollapse: true},
    },

    {
      name: "TermbaseBodyRoute",
      path: "/tb/body",
      component: () => import("@/views/termbase/TermbaseBody"),
      meta: { title: "术语库详情",isCollapse: true },
    },
    {
      name: "extractRoute",
      path: "/extract",
      meta: { isCollapse: true },
      component: () => import("@/views/glossaryExtract/extractor.vue"),
    },
    {
      name: "createProject",
      path: "/project/create",
      meta: { isCollapse: true },
      component: () => import("@/views/workshop/translationProject/createProject"),
    },
    {
      name: "projectDetail",
      path: "/project/detail",
      meta: { isCollapse: true },
      component: () => import("@/views/workshop/translationProject/projectDetail"),
    },
    {
      name: "splitTask",
      path: "/project/task/split",
      meta: { isCollapse: true },
      component: () => import("@/views/workshop/translationProject/distributeTask/index.vue"),
    },
    {
      name: "browseTask",
      path: "/project/task/browse",
      meta: { isCollapse: true },
      component: () => import("@/views/workshop/translationProject/distributeTask/index.vue"),
      props: {
        readonly: true,
      },
    },
    {
      name: "myTaskList",
      path: "/project/myTask/list",
      meta: { isCollapse: true },
      component: () => import("@/views/workshop/myTasks/TaskList"),
    },
  ],
};





const alignmentEditorRoute = {
  name: "AlignmentEditor",
  path: config.prefixUrl + "/alignment/editor",
  component: AlignmentEditorLayoutView,
};

const catEditorRoute = {
  name: "editor",
  path: config.prefixUrl + "/editor",
  component: EditorLayoutView,
  children: [
    {
      name: "translate",
      path: "translate",
      component: () => import("@/views/editor/index.vue"),
    },
    {
      name: "review",
      path: "review",
      component: () => import("@/views/editor/index.vue"),
    },
    {
      name: "proofread",
      path: "proofread",
      component: () => import("@/views/editor/index.vue"),
    },
    {
      name: "previewCAT",
      path: "preview",
      component: () => import("@/views/editor/index.vue"),
    },
  ],
};

export { mainRoute, catEditorRoute, alignmentEditorRoute};
